import styled from 'styled-components';
import { FormFieldMixin } from '../../mixins/components/FormFieldMixin';
export var StyledFormField = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledFormField",
  componentId: "c11n-8-111-1__sc-144pzcf-0"
})(["", ""], FormFieldMixin);